import { Text } from "@mantine/core";
import {
  RoundedNumberFormat,
  type RoundedNumberFormatProps
} from "../../../utils/RoundedNumberFormat";

interface DecimalLabelProps extends RoundedNumberFormatProps {
  fontDanger?: boolean;
  fontSuccess?: boolean;
  fontDangerIfNegative?: boolean;
  fontSuccessIfPositive?: boolean;
  convert?: (
    value: RoundedNumberFormatProps["value"]
  ) => RoundedNumberFormatProps["value"];
}

function DecimalLabel({
  value,
  className,
  convert,
  fontDanger,
  fontSuccess,
  fontDangerIfNegative,
  fontSuccessIfPositive,
  ...other
}: DecimalLabelProps) {
  const convertedValue = convert ? convert(value) : value;

  const fontColor =
    fontDanger || (fontDangerIfNegative && isNegative(convertedValue))
      ? "error"
      : fontSuccess || (fontSuccessIfPositive && isPositive(convertedValue))
        ? "success"
        : undefined;

  return (
    <Text c={fontColor} className={className}>
      <RoundedNumberFormat
        decimalScale={0}
        displayType="text"
        value={convertedValue}
        {...other}
      />
    </Text>
  );
}

function isNegative(value: RoundedNumberFormatProps["value"]) {
  if (value === null || typeof value === "undefined") {
    return false;
  }

  return Number(value) < 0;
}

function isPositive(value: RoundedNumberFormatProps["value"]) {
  if (value === null || typeof value === "undefined") {
    return false;
  }

  return Number(value) > 0;
}

export { DecimalLabel, DecimalLabelProps };
